import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class BeneficiaryService {

  selectedBeneficiary
  destinations
  selectedDestination

  constructor(private http:HttpClient) { }

  getAllBeneficiaries(){
    return this.http.get(`${environment.apiUrl}/benificiaries`)
  }

  addNewBeneficiary(info){
    return this.http.post(`${environment.apiUrl}/benificiaries`, info)
  }

  verifyIfsc(ifsc){
    return this.http.get(`https://ifsc.razorpay.com/${ifsc}`, {headers:{skip:"true"}})
  }

  getAllProviders(country){
    return this.http.get(`${environment.apiUrl}/mobile-providers?country=${country}`)
  }

  getAllBanks(country){
    return this.http.get(`${environment.apiUrl}/banklists?country=${country}`)
  }

  deleteBeneficiary(id){
    return this.http.put(`${environment.apiUrl}/benificiaries/${id}`, {
      "isDeleted": true
    })
  }

  getIdTypes(destination_currency){
    return this.http.get(`${environment.apiUrl}/idtypes?currency=${destination_currency}`)
  }
}
